import React, { Component } from 'react'

export class TypographyThree extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="col-md-12 mgt-30">
                    <div className="card">
                        <div className='card-header'>
                            <div className="card-title">Font Size</div>
                        </div>
                        <div className='card-body'>
                            <div className="card-text mgb-15">
                                Available to using font-size in <code>pixel</code> and <code>rem</code> mode with classes. You can initialize the class like <code>.text-*</code> or <code>.text-r-*</code> like component on the below.
                            </div>
                            <div className="row">
                                <div className="col-md-6 mgb-15">
                                    <div className="table-responsive scroll-semi-dark for-x for-y scroll-thin" style={{maxHeight:'400px'}}>
                                    <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="text-start" width="70%">Text</th>
                                                    <th className="text-end" width="30%">Font Size</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span className="text-10 tcolor-black-3">text-10</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">10px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-11 tcolor-black-3">text-11</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">11px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-12 tcolor-black-3">text-12</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">12px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-13 tcolor-black-3">text-13</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">13px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-14 tcolor-black-3">text-14</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">14px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-15 tcolor-black-3">text-15</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">15px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-16 tcolor-black-3">text-16</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">16px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-17 tcolor-black-3">text-17</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">17px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-18 tcolor-black-3">text-18</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">18px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-19 tcolor-black-3">text-19</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">19px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-20 tcolor-black-3">text-20</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">20px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-21 tcolor-black-3">text-21</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">21px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-22 tcolor-black-3">text-22</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">22px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-23 tcolor-black-3">text-23</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">23px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-24 tcolor-black-3">text-24</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">24px</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-25 tcolor-black-3">text-25</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">25px</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-6 mgb-15">
                                    <div className="table-responsive scroll-semi-dark for-x for-y scroll-thin" style={{maxHeight:'400px'}}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="text-start" width="70%">Text</th>
                                                    <th className="text-end" width="30%">Font Size</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-p35 tcolor-black-3">text-r-p35</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">.35rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-p5 tcolor-black-3">text-r-p5</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">.5rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-p6 tcolor-black-3">text-r-p6</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">.6rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-p7 tcolor-black-3">text-r-p7</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">.7rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-p8 tcolor-black-3">text-r-p8</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">.8rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-p9 tcolor-black-3">text-r-p9</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">.9rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-1 tcolor-black-3">text-r-1</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">1rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-1p5 tcolor-black-3">text-r-1p5</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">1.5rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-2 tcolor-black-3">text-r-2</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">2rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-2p5 tcolor-black-3">text-r-2p5</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">2.5rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-3 tcolor-black-3">text-r-3</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">3rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-3p5 tcolor-black-3">text-r-3p5</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">3.5rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-4 tcolor-black-3">text-r-4</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">4rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-4p5 tcolor-black-3">text-r-4p5</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">4.5rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-5 tcolor-black-3">text-r-5</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">5rem</span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <span className="text-r-5p5 tcolor-black-3">text-r-5p5</span>
                                                    </td>
                                                    <td>
                                                        <span className="pull-right tcolor-black-3">5.5rem</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default TypographyThree
